import { useCurrentSite } from '../useCurrentSite';

export function useCurrentSiteAndTeamIds(): {
  siteCode: string;
  siteUuid: string;
  teamCode: string;
  teamUuid: string;
} {
  const currentSite = useCurrentSite();
  const { code: siteCode, uuid: siteUuid, currentTeam } = currentSite;

  if (!currentTeam) {
    throw new Error('No current team found');
  }

  return {
    siteCode,
    siteUuid,
    teamCode: currentTeam.teamCode,
    teamUuid: currentTeam.uuid,
  };
}
